import { render, staticRenderFns } from "./TabsInsights.vue?vue&type=template&id=0105b592&scoped=true&"
import script from "./TabsInsights.vue?vue&type=script&lang=js&"
export * from "./TabsInsights.vue?vue&type=script&lang=js&"
import style0 from "./TabsInsights.vue?vue&type=style&index=0&id=0105b592&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0105b592",
  null
  
)

export default component.exports